module.exports = __webpack_public_path__ + "img/五粮液.8d8a20b4.jpg";